import { RegValuePropContainer } from "@/components/organisms/RegistrationValueProposition/RegValuePropContainer";

/**
 * Registration value proposition (Figma: ACP Registration — Value Proposition).
 */
export function RegValuePropPage() {
  return <RegValuePropContainer />;
}
